import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex mb-2 pl-2" }
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = { class: "align-self-end" }
const _hoisted_4 = { class: "demo-pagination-block mt-3 d-flex justify-content-end" }
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Operation = _resolveComponent("Operation")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_EditPen = _resolveComponent("EditPen")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_AddTags = _resolveComponent("AddTags")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_input, {
        class: "me-auto",
        style: {"width":"240px"},
        modelValue: _ctx.searchText,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
        placeholder: _ctx.t('Filter'),
        "prefix-icon": _ctx.Filter,
        onInput: _ctx.onFilterInputed,
        clearable: ""
      }, null, 8, ["modelValue", "placeholder", "prefix-icon", "onInput"]),
      (_ctx.userInfoStore.permissions.some((x) => x === 420))
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: _ctx.onAddSiteClicked
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("create")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_popover, {
          placement: "bottom",
          onHide: _ctx.onColDisplayCtrlPanelHidded,
          trigger: "click",
          Title: _ctx.t('column')
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_el_button, { link: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { size: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Operation)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[0],
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.colDisplayCtrl[0]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("site")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[1],
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.colDisplayCtrl[1]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("factorys")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.colDisplayCtrl[2],
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.colDisplayCtrl[2]) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("remark")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["onHide", "Title"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref: "manufMethodListTableRef",
        class: "w-100",
        data: _ctx.displaySiteList,
        onSortChange: _ctx.onSortChanged
      }, {
        default: _withCtx(() => [
          (_ctx.colDisplayCtrl[0])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                "min-width": "80",
                sortable: "custom",
                label: _ctx.t('site'),
                prop: "name"
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[1])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                "min-width": "80",
                label: _ctx.t('factorys'),
                prop: "factories"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.factories.map((x) => x.name).toString()), 1)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.colDisplayCtrl[2])
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 2,
                "min-width": "200",
                sortable: "custom",
                label: _ctx.t('remark'),
                prop: "remark"
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            width: "80",
            fixed: "right",
            label: _ctx.t('operation'),
            prop: "operate",
            class: "operateBtnGroup d-flex"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                link: "",
                disabled: !_ctx.userInfoStore.permissions.some((x) => x === 420),
                type: _ctx.userInfoStore.permissions.some((x) => x === 420) ? 'success' : 'info',
                onClick: ($event: any) => (_ctx.onModifySiteClicked(scope.row.id))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditPen)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["disabled", "type", "onClick"]),
              _createVNode(_component_el_button, {
                link: "",
                disabled: !_ctx.userInfoStore.permissions.some((x) => x === 420),
                type: _ctx.userInfoStore.permissions.some((x) => x === 420) ? 'danger' : 'info',
                onClick: ($event: any) => (_ctx.onDeleteSiteClicked(scope.row.id))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Delete)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["disabled", "type", "onClick"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data", "onSortChange"])), [
        [
          _directive_loading,
          _ctx.isSiteListTableLoading,
          void 0,
          {
            fullscreen: true,
            lock: true
          }
        ]
      ])
    ]),
    _createVNode(_component_el_row, {
      justify: "end",
      class: "mt-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_pagination, {
                currentPage: _ctx.currentPage,
                "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentPage) = $event)),
                "page-size": _ctx.pageSize,
                "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pageSize) = $event)),
                "pager-count": _ctx.paginatorSetup.pagerCount,
                layout: _ctx.paginatorSetup.layout,
                small: _ctx.paginatorSetup.small,
                "page-sizes": [2, 50, 100, 150, 200],
                total: _ctx.filterdListLength,
                onSizeChange: _ctx.onPagesizeChanged,
                onCurrentChange: _ctx.onCurrentPageChanged,
                justify: "end"
              }, null, 8, ["currentPage", "page-size", "pager-count", "layout", "small", "total", "onSizeChange", "onCurrentChange"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: _ctx.isShowAddSiteDialog,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isShowAddSiteDialog) = $event)),
      title: _ctx.t('create')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isShowAddSiteDialog = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onSubmitNewSiteClicked()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"])),
          ref: "addSiteFormRef",
          model: _ctx.newSiteFormData,
          rules: _ctx.addSiteFormRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.site'),
              prop: "name",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.newSiteFormData.name,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newSiteFormData.name) = $event)),
                  loading: _ctx.isSiteOptionLoading,
                  placeholder: _ctx.t('placeholder.select'),
                  onVisibleChange: _ctx.onSiteOptionListShown
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.siteOptions, (site) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: site,
                        label: site,
                        value: site
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "loading", "placeholder", "onVisibleChange"])
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.factories'),
              prop: "factoryNames",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AddTags, {
                  modelValue:  _ctx.newSiteFormData.factoryNames,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (( _ctx.newSiteFormData.factoryNames) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.remark'),
              prop: "remark",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.newSiteFormData.remark,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newSiteFormData.remark) = $event)),
                  rows: 4,
                  type: "textarea",
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "label-width"])
          ]),
          _: 1
        }, 8, ["model", "rules"])), [
          [
            _directive_loading,
            _ctx.isAddDialogLoading,
            void 0,
            {
              fullscreen: true,
              lock: true
            }
          ]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: _ctx.isShowModifySiteDialog,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.isShowModifySiteDialog) = $event)),
      title: _ctx.t('modify')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_el_button, {
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isShowModifySiteDialog = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onSubmitModifySiteClicked()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          onSubmit: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["prevent"])),
          ref: "modifySiteFormRef",
          model: _ctx.selectedSiteData,
          rules: _ctx.modifySiteFormRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.site'),
              prop: "name",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.selectedSiteData.name), 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.factories'),
              prop: "factoryNames",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AddTags, {
                  modelValue: _ctx.selectedFactoryNames,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedFactoryNames) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.remark'),
              prop: "remark",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.selectedSiteData.remark,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedSiteData.remark) = $event)),
                  rows: 4,
                  type: "textarea",
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "label-width"])
          ]),
          _: 1
        }, 8, ["model", "rules"])), [
          [
            _directive_loading,
            _ctx.isModifyDialogLoading,
            void 0,
            {
              fullscreen: true,
              lock: true
            }
          ]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}